import Vue from 'vue';
import shippingProviderTransformer from './../../transformers/shippingProvider';

const success = (data, resolve) => {
  resolve(shippingProviderTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(shippingProviderTransformer.fetch(errors));
};

export default (id, shippingProvider) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/shipping_providers/${id}`, shippingProvider)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/shippingProvider/update.js